import React from 'react'
import { OptionsItem, OptionsType } from './Options.type'
import './options.scss'

const Option:React.FC<OptionsItem> = ({
  label, value, chooseValue, onChange,
}) => (
  <div className={'options__item'} onClick={() => onChange && onChange(value)}>
    <div className={'options__item-inactive'}>
      {chooseValue === value && <div className={'options__item-active'} />}
    </div>
    <span className={'options__item-label'}>{label}</span>
  </div>
)

const Options:React.FC<OptionsType> = ({
  options, chooseValue, className, onChange,
}) => (
  <div className={`${className} options`}>
    {
                options.map(({ value, label }) => (
                  <Option
                    key={value}
                    value={value}
                    label={label}
                    chooseValue={chooseValue}
                    onChange={onChange}
                  />
                ))
            }
  </div>
)

export default Options
